var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SovosProductMenu } from 'mosaic-react';
import useSovosPlatformContext from '../sovos-platform-context';
import generateSupportItemKey from '../utils/supportItemKey';
const mapProduct = (p) => ({
    id: p.id,
    logoMonoUrl: p.iconMonoEncodedSvg,
    logoUrl: p.iconEncodedSvg,
    name: p.name,
});
const mapSupportItem = (si, i18nInstance) => {
    if (i18nInstance) {
        const localeText = i18nInstance.t(generateSupportItemKey(si.url), {
            returnObjects: true,
        });
        return {
            additionalText: localeText.additionalText,
            iconUrl: si.iconEncodedSvg,
            linkText: localeText.linkText,
            url: si.url,
        };
    }
    return null;
};
const SovosSuiteProductMenu = (_a) => {
    var { onSelectProduct } = _a, rest = __rest(_a, ["onSelectProduct"]);
    const { activeProduct, availableProducts, i18nInstance, supportItems } = useSovosPlatformContext();
    let selectedProduct = {};
    if (activeProduct) {
        selectedProduct = mapProduct(activeProduct);
    }
    let products = [];
    if (availableProducts) {
        products = availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.map(mapProduct);
    }
    const handleSelectProduct = (product) => {
        const newProduct = availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.find((p) => p.id === product.id);
        if (onSelectProduct) {
            onSelectProduct(newProduct);
            return;
        }
        if (newProduct === null || newProduct === void 0 ? void 0 : newProduct.redirectUrl) {
            window.location.href = newProduct.redirectUrl;
        }
    };
    const _b = rest, { products: ignoredProducts, selectedProduct: ignoredSelectedProduct, supportItems: ignoredSupportItems } = _b, additionalProps = __rest(_b, ["products", "selectedProduct", "supportItems"]);
    return (_jsx(SovosProductMenu, Object.assign({ onSelectProduct: handleSelectProduct, products: products, selectedProduct: selectedProduct, supportItems: supportItems === null || supportItems === void 0 ? void 0 : supportItems.map((si) => mapSupportItem(si, i18nInstance)) }, additionalProps)));
};
export default SovosSuiteProductMenu;
